module.exports = require("@apollo/client/link/core");